import { render, staticRenderFns } from "./PlatformCascader.vue?vue&type=template&id=6b6e2e07"
import script from "./PlatformCascader.vue?vue&type=script&lang=js"
export * from "./PlatformCascader.vue?vue&type=script&lang=js"
import style0 from "./PlatformCascader.vue?vue&type=style&index=0&id=6b6e2e07&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports